export const FETCH_CLIENTES_EVENTS_REQUEST = "FETCH_CLIENTES_EVENTS_REQUEST";
export const FETCH_CLIENTES_EVENTS_SUCCESS = "FETCH_CLIENTES_EVENTS_SUCCESS";
export const FETCH_CLIENTES_EVENTS_FAILURE = "FETCH_CLIENTES_EVENTS_FAILURE";
